(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvFileUpload', drvFileUpload);

    drvFileUpload.$inject = [];
    drvFileUploadCtrl.$inject = ['$scope', 'DialogService'];
    
    /**
     * # Scope Parameters
     * accept - List of accepted file types
     * files - Array of selected files
     * api - If provided, this object will be populated with api methods
     *   - {function} removeAll - Remove all selected files.
     */
    function drvFileUpload() {
        var directive = {
            link: link,
            controller: drvFileUploadCtrl,
            restrict: 'EA',
            template: '<lf-ng-md-file-input drag lf-files="files" lf-drag-and-drop-label="{{label || \'Drag & drop file here...\'}}" accept="{{accept}}" lf-api="lfFileInputApi" ng-attr-multiple="{{multiple || undefined}}"></lf-ng-md-file-input>' +
                      '<p><a href="" ng-if="files && files.length > 1" ng-click="showFileNames(files)">Show file names</a></p>',
            scope: {
                accept: '@',
                files: '=',
                api: '=',
                multiple: '@',
                label: '@'
            }
        };
        return directive;

        function link(scope, element, attrs) {
        }
    }

    function drvFileUploadCtrl($scope, DialogService) {
        if (!_.isNil($scope.api)) {
            $scope.api.removeAll = apiRemoveAll;
        }

        function apiRemoveAll() {
            $scope.lfFileInputApi.removeAll();
        }

        $scope.showFileNames = function showFileNames(files) {
            var alertHtml = '<ul>';

            for (var i = 0; i < files.length; i++) {
                alertHtml += '<li>' + files[i].lfFileName + '</li>';
            }

            alertHtml += '</ul>';

            DialogService.alertHtml(alertHtml);
        };
    }
})();